<template>
  <div class="wheel-battle-score-entry">
    <van-cell-group :border="false" class="entry-method">
      <van-cell title="录入方式" value="计分" is-link />
    </van-cell-group>

    <div class="score-panel">
      <wheel-battle-match-picker
        :home-team="subMatch.homeTeam"
        :away-team="subMatch.awayTeam"
        :match-logo="matchLogo"
      />

      <div class="score-row">
        <input
          v-model.number="homeScore"
          type="number"
          min="0"
          inputmode="numeric"
          class="score-input"
          @blur="normalizeScore('home')"
        />
        <div class="score-label">比分</div>
        <input
          v-model.number="awayScore"
          type="number"
          min="0"
          inputmode="numeric"
          class="score-input"
          @blur="normalizeScore('away')"
        />
      </div>

      <div class="stats-link" @click="onAddStats">添加技术统计数据</div>
    </div>

    <div class="footer">
      <div class="footer-inner">
        <div class="delete-action" @click="onDelete">
          <van-icon name="delete-o" size="20" color="#666" />
          <span>删除</span>
        </div>
        <van-button
          type="primary"
          round
          class="submit-btn"
          :loading="submitting"
          :disabled="loading"
          @click="onSubmit"
        >
          提交
        </van-button>
      </div>
      <div class="footer-safe-area" />
    </div>

    <van-popup
      v-model="showSuccessOverlay"
      position="bottom"
      round
      :close-on-click-overlay="false"
      class="score-success-popup"
    >
      <div class="success-sheet">
        <div class="success-header">
          <van-icon name="checked" color="#17ae5f" size="22" />
          <span class="success-title">录入成功</span>
        </div>
        <div v-if="submitResult" class="success-desc">
          <div>{{ submitResult.winnerLabel }}</div>
          <div>{{ submitResult.rotationLabel }}</div>
        </div>

        <div v-if="submitResult && submitResult.nextMatch" class="next-match-card">
          <div class="next-match-title">下场对战</div>
          <wheel-battle-match-picker
            :home-team="submitResult.nextMatch.defender"
            :away-team="submitResult.nextMatch.challenger"
            :match-logo="matchLogo"
            defender-label="擂主"
            highlight-home
            clickable
            @click-home="onNextMatchPickTeam('home')"
            @click-away="onNextMatchPickTeam('away')"
          />
          <van-button
            type="primary"
            round
            block
            class="create-next-btn"
            :loading="creatingNext"
            @click="onCreateNext"
          >
            创建下一场
          </van-button>
        </div>

        <div class="success-actions">
          <div class="action-btn" @click="onReturnEdit">
            <van-icon name="edit" size="16" color="#337ecc" />
            <span>返回修改</span>
          </div>
          <div class="action-btn action-btn-danger" @click="onWheelEnd">
            <img class="wheel-end-icon" :src="wheelEndIconUrl" alt="">
            <span>车轮结束</span>
          </div>
        </div>
        <div class="sheet-safe-area" />
      </div>
    </van-popup>

    <van-popup v-model="showNextTeamPicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择球队"
        value-key="name"
        :columns="nextMatchTeamPickerColumns"
        @confirm="onNextTeamConfirm"
        @cancel="showNextTeamPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, Icon, Button, Toast, Dialog, Popup, Picker } from 'vant'
Vue.use(Cell).use(CellGroup).use(Icon).use(Button).use(Toast).use(Dialog).use(Popup).use(Picker)

import WheelBattleMatchPicker from './components/WheelBattleMatchPicker.vue'
import {
  adminGetBMMatchWheelBattleChildGame,
  adminConfirmBMMatchWheelBattleChildGameResult,
  adminUpdateBMMatchWheelBattleChildGameResult,
  adminDeleteBMMatchWheelBattleChildGame,
  adminCreateBMMatchWheelBattleChildGame,
  adminFinishBMMatchWheelBattleParentGame
} from '@/api/wheel-battle'
import {
  scoreEntryStateFromChildGameDetail,
  buildScoreSubmitResultFromChildGameDetail
} from '@/api/wheel-battle/adapter'
import {
  buildCreateChildGameParams,
  buildConfirmChildGameResultParams,
  buildUpdateChildGameResultParams,
  buildDeleteChildGameParams,
  buildFinishParentGameParams
} from './utils/api-params'
import {
  saveScoreDraft,
  loadScoreDraft,
  clearScoreDraft
} from './utils/score-draft'
export default {
  name: 'WheelBattleScoreEntry',
  components: {
    WheelBattleMatchPicker
  },
  data: function () {
    return {
      parentGameId: '',
      subMatchId: '',
      unionMatchId: '',
      matchId: '',
      matchLogo: '',
      loading: false,
      childGameDetail: null,
      subMatch: {
        homeTeam: {},
        awayTeam: {}
      },
      homeScore: 0,
      awayScore: 0,
      isConfirmed: false,
      submitting: false,
      showSuccessOverlay: false,
      submitResult: null,
      creatingNext: false,
      showNextTeamPicker: false,
      nextPickerSide: 'home',
      wheelEndIconUrl: 'https://images.snsports.cn/FmnT0GNMpP2DuAE7PT6ya1xYHRX8'
    }
  },
  computed: {
    nextMatchTeamOptions: function () {
      var childGame = this.childGameDetail && this.childGameDetail.childGame
      var orderAfter = (childGame && childGame.rotationOrderAfter) || []
      var orderBefore = (childGame && childGame.rotationOrderBefore) || []
      var source = orderAfter.length ? orderAfter : orderBefore
      return source.map(function (team) {
        return {
          id: team.id != null ? String(team.id) : '',
          name: team.name || '',
          badge: team.badge || '',
          clothesColor: team.clothesColor || ''
        }
      }).filter(function (team) {
        return !!team.id
      })
    },
    nextMatchTeamPickerColumns: function () {
      var nextMatch = this.submitResult && this.submitResult.nextMatch
      if (!nextMatch) {
        return this.nextMatchTeamOptions
      }
      var otherId = this.nextPickerSide === 'home'
        ? (nextMatch.challenger && nextMatch.challenger.id)
        : (nextMatch.defender && nextMatch.defender.id)
      return this.nextMatchTeamOptions.filter(function (team) {
        return team.id !== otherId
      })
    }
  },
  mounted: function () {
    this.parentGameId = this.$route.params.parentGameId || ''
    this.subMatchId = this.$route.params.subMatchId || ''
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.loadSubMatch()
  },
  beforeRouteLeave: function (to, from, next) {
    this.persistScoreDraft()
    next()
  },
  methods: {
    persistScoreDraft: function () {
      if (!this.subMatchId) {
        return
      }
      this.normalizeScore('home')
      this.normalizeScore('away')
      saveScoreDraft(this.subMatchId, {
        homeScore: this.homeScore,
        awayScore: this.awayScore
      })
    },
    loadSubMatch: function () {
      var self = this
      if (!this.subMatchId) {
        Toast('比赛不存在')
        return
      }
      this.loading = true
      adminGetBMMatchWheelBattleChildGame({
        gameId: self.subMatchId
      }).then(function (res) {
        self.loading = false
        if (res && res.error) {
          Toast(res.msg || '加载失败')
          return
        }
        var page = scoreEntryStateFromChildGameDetail(res && res.data)
        if (!page) {
          Toast('比赛不存在')
          return
        }
        self.applyScoreEntryState(page)
      }).catch(function () {
        self.loading = false
        Toast('加载失败')
      })
    },
    applyScoreEntryState: function (page) {
      this.childGameDetail = page.apiDetail || null
      if (page.parentGameId) {
        this.parentGameId = page.parentGameId
      }
      if (page.childGameId) {
        this.subMatchId = page.childGameId
      }
      var apiDetail = page.apiDetail || {}
      var childGame = apiDetail.childGame || {}
      var parentGame = apiDetail.parentGame || {}
      this.matchId = String(
        childGame.matchId || parentGame.matchId || ''
      )
      this.matchLogo = page.unionMatchIcon || ''
      this.subMatch = page.subMatch || { homeTeam: {}, awayTeam: {} }
      if (page.homeScore >= 0) {
        this.homeScore = page.homeScore
      } else {
        this.homeScore = 0
      }
      if (page.awayScore >= 0) {
        this.awayScore = page.awayScore
      } else {
        this.awayScore = 0
      }
      this.isConfirmed = !!page.isConfirmed
      var draft = loadScoreDraft(this.subMatchId)
      if (draft) {
        if (draft.homeScore != null && !isNaN(draft.homeScore) && draft.homeScore >= 0) {
          this.homeScore = parseInt(draft.homeScore, 10)
        }
        if (draft.awayScore != null && !isNaN(draft.awayScore) && draft.awayScore >= 0) {
          this.awayScore = parseInt(draft.awayScore, 10)
        }
      }
    },
    fetchChildGameDetail: function () {
      var self = this
      return adminGetBMMatchWheelBattleChildGame({
        gameId: self.subMatchId
      }).then(function (res) {
        if (res && res.error) {
          return { error: res.error, msg: res.msg }
        }
        return { data: res && res.data }
      })
    },
    normalizeScore: function (side) {
      var val = side === 'home' ? this.homeScore : this.awayScore
      if (val === '' || val === null || isNaN(val) || val < 0) {
        val = 0
      } else {
        val = parseInt(val, 10)
      }
      if (side === 'home') {
        this.homeScore = val
      } else {
        this.awayScore = val
      }
    },
    onAddStats: function () {
      this.persistScoreDraft()
      this.$router.push({
        path: '/match-manage/wheel-battle/stats-entry/' + this.parentGameId + '/' + this.subMatchId,
        query: { unionMatchId: this.unionMatchId }
      })
    },
    onDelete: function () {
      var self = this
      Dialog.confirm({
        title: '删除比赛',
        message: '确定删除该子场次吗？此操作不可恢复。'
      }).then(function () {
        return adminDeleteBMMatchWheelBattleChildGame(
          buildDeleteChildGameParams({
            gameId: self.subMatchId
          })
        )
      }).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '删除失败')
          return
        }
        clearScoreDraft(self.subMatchId)
        Toast.success('已删除')
        self.$router.back()
      }).catch(function () {})
    },
    onSubmit: function () {
      var self = this
      this.normalizeScore('home')
      this.normalizeScore('away')
      if (this.homeScore === this.awayScore && this.homeScore !== 0) {
        Toast('比分不能相同')
        return
      }
      this.submitting = true
      var isUpdate = this.isConfirmed
      var scoreParams = {
        gameId: self.subMatchId,
        homeScore: self.homeScore,
        awayScore: self.awayScore
      }
      var submitRequest = isUpdate
        ? adminUpdateBMMatchWheelBattleChildGameResult(buildUpdateChildGameResultParams(scoreParams))
        : adminConfirmBMMatchWheelBattleChildGameResult(buildConfirmChildGameResultParams(scoreParams))
      submitRequest.then(function (res) {
        if (res && res.error) {
          self.submitting = false
          Toast(res.msg || '提交失败，请稍后重试')
          return
        }
        return self.fetchChildGameDetail()
      }).then(function (res) {
        self.submitting = false
        if (!res) {
          return
        }
        if (res.error) {
          Toast(res.msg || '提交失败，请稍后重试')
          return
        }
        clearScoreDraft(self.subMatchId)
        var page = scoreEntryStateFromChildGameDetail(res.data)
        if (page) {
          self.applyScoreEntryState(page)
        }
        self.submitResult = buildScoreSubmitResultFromChildGameDetail(res.data)
        if (!self.submitResult) {
          Toast('提交成功')
          if (!isUpdate) {
            self.goParentDetail({ tab: 'score' })
          }
          return
        }
        self.showSuccessOverlay = true
      }).catch(function () {
        self.submitting = false
        Toast('提交失败，请稍后重试')
      })
    },
    onNextMatchPickTeam: function (side) {
      if (!this.nextMatchTeamOptions.length) {
        Toast('暂无候选球队')
        return
      }
      this.nextPickerSide = side
      this.showNextTeamPicker = true
    },
    onNextTeamConfirm: function (team) {
      this.showNextTeamPicker = false
      if (!team || !this.submitResult || !this.submitResult.nextMatch) {
        return
      }
      var picked = {
        id: team.id != null ? String(team.id) : '',
        name: team.name || '',
        badge: team.badge || '',
        clothesColor: team.clothesColor || ''
      }
      if (this.nextPickerSide === 'home') {
        this.$set(this.submitResult.nextMatch, 'defender', picked)
      } else {
        this.$set(this.submitResult.nextMatch, 'challenger', picked)
      }
    },
    onCreateNext: function () {
      var self = this
      var nextMatch = this.submitResult && this.submitResult.nextMatch
      if (!nextMatch) {
        return
      }
      if (!nextMatch.defender || !nextMatch.defender.id || !nextMatch.challenger || !nextMatch.challenger.id) {
        Toast('请选择对阵球队')
        return
      }
      if (nextMatch.defender.id === nextMatch.challenger.id) {
        Toast('主客队不能相同')
        return
      }
      this.creatingNext = true
      var params = buildCreateChildGameParams({
        gameId: self.parentGameId,
        payload: {
          homeTeam: nextMatch.defender,
          awayTeam: nextMatch.challenger
        }
      })
      adminCreateBMMatchWheelBattleChildGame(params).then(function (res) {
        self.creatingNext = false
        if (res && res.error) {
          Toast(res.msg || '创建失败，请稍后重试')
          return
        }
        var createdId = res && res.data && res.data.id
        if (!createdId) {
          Toast('创建失败，请稍后重试')
          return
        }
        self.switchToSubMatch(createdId)
      }).catch(function () {
        self.creatingNext = false
        Toast('创建失败，请稍后重试')
      })
    },
    switchToSubMatch: function (subMatchId) {
      if (!subMatchId) {
        return
      }
      this.showSuccessOverlay = false
      this.submitResult = null
      this.isConfirmed = false
      this.subMatchId = subMatchId
      if (this.$route.params.subMatchId !== subMatchId) {
        this.$router.replace({
          path: '/match-manage/wheel-battle/score-entry/' + this.parentGameId + '/' + subMatchId,
          query: { unionMatchId: this.unionMatchId }
        }).catch(function () {})
      }
      this.loadSubMatch()
    },
    onReturnEdit: function () {
      this.showSuccessOverlay = false
    },
    onWheelEnd: function () {
      var self = this
      Dialog.confirm({
        title: '车轮结束',
        message: '确定结束本场车轮战吗？'
      }).then(function () {
        return adminFinishBMMatchWheelBattleParentGame(
          buildFinishParentGameParams({
            parentGameId: self.parentGameId
          })
        )
      }).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '操作失败，请稍后重试')
          return
        }
        self.showSuccessOverlay = false
        Toast.success('已结束')
        self.goParentDetail({ tab: 'score' })
      }).catch(function () {})
    },
    goParentDetail: function (extraQuery) {
      var query = Object.assign({ unionMatchId: this.unionMatchId }, extraQuery || {})
      this.$router.replace({
        path: '/match-manage/wheel-battle/parent-detail/' + this.parentGameId,
        query: query
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-score-entry {
  min-height: 100vh;
  background: #f1f1f1;
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
}

.entry-method {
  padding: 16px 10px;
  background-color: #f1f1f1;

  ::v-deep .van-cell {
    padding: 14px 16px;
    border-radius: 5px;
  }

  ::v-deep .van-cell__title {
    color: #999999;
  }

  ::v-deep .van-cell__value {
    color: #333;
  }
}

.score-panel {
  background: #fff;
  padding: 20px 16px 24px;

  ::v-deep .match-picker {
    margin: 0;
  }
}

.score-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.score-input {
  width: 126px;
  height: 42px;
  padding: 0;
  box-sizing: border-box;
  background: #eeeeee;
  border: none;
  border-radius: 6px;
  font-size: 20px;
  font-weight: 400;
  color: #666666;
  text-align: center;
  outline: none;
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    background: #e2e2e2;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.score-label {
  margin: 0 16px;
  font-size: 14px;
  color: #999999;
}

.stats-link {
  margin-top: 36px;
  text-align: center;
  font-size: 14px;
  color: #337ecc;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
}

.footer-inner {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-safe-area {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}

.delete-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 11px;
  color: #666;

  span {
    margin-top: 2px;
  }
}

.submit-btn {
  min-width: 120px;
  height: 40px;
  background: #337ecc;
  border-color: #337ecc;
}

.score-success-popup {
  width: 100%;
}

.success-sheet {
  width: 100%;
  padding: 24px 16px 0;
  box-sizing: border-box;
  background: #fff;
}

.sheet-safe-area {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}

.success-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-title {
  margin-left: 6px;
  font-size: 18px;
  font-weight: 600;
  color: #17ae5f;
}

.success-desc {
  margin-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #666666;
  line-height: 1.8;
}

.next-match-card {
  margin-top: 20px;
  padding: 14px 12px;
  background: #f7f7f7;
  border-radius: 8px;

  ::v-deep .match-picker {
    margin-top: 0px;
  }
}

.next-match-title {
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.create-next-btn {
  // margin-top: 20px;
  height: 44px;
  background: #70aee0;
  border-color: #70aee0;
}

.success-actions {
  margin-top: 14px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  margin-bottom: 8px;
  background: #F7F7F7;
  border-radius: 8px;
  font-size: 15px;
  color: #337ecc;

  span {
    margin-left: 6px;
  }

  &:active {
    background: #f7f8fa;
  }
}

.action-btn-danger {
  color: #ee0a24;
  margin-bottom: 24px;
}

.wheel-end-icon {
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
}
</style>
